import { t } from 'helpers/i18n';
import React from 'react';
import './ProjectListBottomBar.scss';

const ProjectListBottomBar: React.FC = () => {
  return (
    <div className="project-list-bottom-bar">
      <span style={{ color: '#DCDEE9', marginLeft: 84 }}>
        {t('teko_copyrights')}
      </span>
    </div>
  );
};

export default ProjectListBottomBar;
